/**
 * Mixin to help with FeatureArticles.
 */
import { getArticleIngressImageSrc } from '@/helpers/image-resources.js';

export default {

    methods: {

        getArticleAuthor: function (item) {
            const editor = item && _.head(item.Editors);
            return (editor && !editor.HideName && editor.EditorName) || '';
        },

        /**
         * Article publish date comes from the first date edited.
         */
        getArticlePublishDate: function (item) {
            return this.$helpers.getFirstDateEdited(item);
        },

        /**
         * Article publish date as string.
         */
        getArticlePublishDateString: function (item) {
            return this.$helpers.toLocaleDateString(
                this.getArticlePublishDate(item),
                this.$i18n.locale);
        },

        getArticleIngressImageSrc,

        getIngressText: function (item) {
            return item?.IngressText || '';
        },

        /**
         * Get FeatureArticles from ChildItems (or deprecated Children).
         */
        getActorArticles: function (actor) {
            if (!actor || !(actor.ChildItems || actor.Children)) {
                return [];
            }

            let articles = [];
            if (actor.ChildItems) {
                // filter only published items and "unwrap"
                articles = _.compact(_.map(actor.ChildItems, (item) => {
                    if (item.FeatureArticle && item.FeatureArticle.Publish && item.FeatureArticle.Publish.IsPublished) {
                        return item.FeatureArticle;
                    }
                }));
            }
            if (!articles && actor.Children) { // DEPRECATED
                articles = _.filter(actor.Children, (item) => {
                    // assume that all Children are FeatureArticles...
                    return item.Publish && item.Publish.IsPublished;
                });
                console.warn("Actor has deprecated Children attribute");
            }

            return articles;
        },

        /**
         * Get Organization FeatureArticles.
         */
        getOrganizationArticles: function (organization, articleTag) {
            if (!organization || !(organization.ChildItems || organization.Children)) {
                return [];
            }

            let articles = [];
            if (organization.ChildItems) {
                // filter only published items and "unwrap"
                articles = _.compact(_.map(organization.ChildItems, (item) => {
                    if (item.FeatureArticle && item.FeatureArticle.Publish && item.FeatureArticle.Publish.IsPublished) {
                        return item.FeatureArticle;
                    }
                }));
            }
            if (!articles.length && organization.Children) { // DEPRECATED
                articles = _.filter(organization.Children, (item) => {
                    // assume that all Children are FeatureArticles...
                    return item.Publish && item.Publish.IsPublished;
                });
                if (!this.isTestEnv) {
                    console.warn("Organization has deprecated Children attribute");
                }
            }

            // filter by tags
            if (articleTag && articles.length) {
                // only "history" articleTag is currently supported (WIP)
                if (articleTag === 'history') {
                    articles = _.filter(articles, (item) => {
                        return (item && _.find(item.Tags, {Name: 'history', Taxonomy: 'contentgroup'}));
                    });
                }
            }

            return articles;
        }
    }
};
